import type { ReactNode } from "react";
import { Icon, Kbd } from "../components/ui/index.tsx";
import { t } from "../i18n/index.ts";

function ControlRow({ keys, children }: { keys: ReactNode[]; children: ReactNode }) {
  return (
    <>
      <div className="keys">
        {keys.map((k, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: a fixed, static key list
          <Kbd key={i}>{k}</Kbd>
        ))}
      </div>
      <div>{children}</div>
    </>
  );
}

/** The full control list, shown in the pause panel and while waiting for a fight. */
export function ControlsGrid() {
  return (
    <div className="controls-grid">
      <ControlRow keys={["W", "A", "S", "D"]}>{t.match.controls.move}</ControlRow>
      <ControlRow keys={[<Icon key="mouse" name="mouse" label={t.match.mouse.move} />]}>
        {t.match.controls.look}
      </ControlRow>
      <ControlRow keys={[t.match.mouse.left, t.match.mouse.right]}>
        {t.match.controls.armL} / {t.match.controls.armR}
      </ControlRow>
      <ControlRow keys={["Q", "E"]}>
        {t.match.controls.legL} / {t.match.controls.legR}
      </ControlRow>
      <ControlRow keys={["F"]}>{t.match.controls.aimAlt}</ControlRow>
      <ControlRow keys={["Shift"]}>{t.match.controls.aimLow}</ControlRow>
      <ControlRow keys={["R", "T"]}>{t.match.controls.arcs}</ControlRow>
      <ControlRow keys={[t.match.mouse.left, t.match.mouse.right]}>
        {t.match.controls.combo}
      </ControlRow>
      <ControlRow keys={["Space"]}>{t.match.controls.guard}</ControlRow>
      <ControlRow keys={["Space", "F"]}>{t.match.controls.guardBody}</ControlRow>
      <ControlRow keys={["Space", "Shift"]}>{t.match.controls.check}</ControlRow>
      <ControlRow keys={["."]}>{t.match.controls.stance}</ControlRow>
      <ControlRow keys={["Z", "C"]}>{t.match.controls.lean}</ControlRow>
      <ControlRow keys={["X"]}>{t.match.controls.duck}</ControlRow>
      <ControlRow keys={["V"]}>{t.match.controls.step}</ControlRow>
    </div>
  );
}
